import { SbBlokData, storyblokEditable, StoryblokServerComponent } from "@storyblok/react/rsc"

import { BlokProps } from "@helpers/StoryblokHelpers"
import { ClinicStaffSectionStoryblok } from "@storyblok-types"

import { TwoColumnsAccordion } from "@/components/ui-library/accordion/TwoColumnsAccordion"
import UIAccordion from "@ui-library/accordion/Accordion"
import Col from "@ui-library/grid/Col"
import Row from "@ui-library/grid/Row"
import GridWrapper from "@ui-library/grid/Wrapper"

export const ClinicStaffSection = ({ blok }: BlokProps<ClinicStaffSectionStoryblok>) => (
  <>
    {blok.intro?.map(item => <StoryblokServerComponent key={item._uid} blok={item} />)}
    <GridWrapper background="surface">
      <Row justifyContent="center" justifyContentMobile="center">
        <Col className={"lg:text-center"} grid={!blok.two_columns ? { xs: 12, sm: 12, md: 10, lg: 8, xl: 8 } : {}}>
          {blok.two_columns ? (
            <TwoColumnsAccordion sections={blok.groups} visibleRowsLimit={blok.visible_rows_limit} />
          ) : (
            <UIAccordion type="single" {...storyblokEditable(blok as SbBlokData)}>
              {blok.groups?.map(item => <StoryblokServerComponent key={item._uid} blok={item} />)}
            </UIAccordion>
          )}
        </Col>
      </Row>
    </GridWrapper>
  </>
)

export default ClinicStaffSection
